import { render, staticRenderFns } from "./communityresident.vue?vue&type=template&id=4161b7a1&scoped=true&"
import script from "./communityresident.vue?vue&type=script&lang=js&"
export * from "./communityresident.vue?vue&type=script&lang=js&"
import style0 from "./communityresident.vue?vue&type=style&index=0&id=4161b7a1&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4161b7a1",
  null
  
)

export default component.exports